import etlDashboard from 'SystemAdministration/ducks/etlDashboard';

export default {
  etlStatuses: etlDashboard,
};
